module.exports = __webpack_public_path__ + "img/20200912_154736.2279d485.jpg";